import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { AbstractView } from 'src/app/core/abstract_view';
import AOS from 'aos';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss'],
})
export class AppMainComponent
    extends AbstractView
    implements AfterViewInit, OnInit, OnDestroy
{
    activeTabIndex: number;

    sidebarActive: boolean;

    layoutMode = 'overlay';

    darkMenu = false;

    topbarMenuActive: boolean;

    sidebarClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: any;

    configActive: boolean;

    configClick: boolean;

    inputStyle = 'outlined';

    ripple = true;

    compactMode = false;

    pinned = false;

    isNavigating = false;

    constructor(
        private messageService: MessageService,
        public router: Router,
        public renderer: Renderer2,
        private primengConfig: PrimeNGConfig
    ) {
        super(messageService, router);
    }

    ngOnInit() {
        AOS.init();
        try { this.pinned = localStorage.getItem('sidebarPinned') === '1'; } catch { this.pinned = false; }
        this.layoutMode = this.pinned ? 'static' : 'overlay';
        this.primengConfig.ripple = true;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.isNavigating = true;
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.isNavigating = false;
            }
        });
    }

    ngAfterViewInit() {
        this.documentClickListener = this.renderer.listen(
            'body',
            'click',
            (event) => {
                if (!this.topbarItemClick) {
                    this.activeTopbarItem = null;
                    this.topbarMenuActive = false;
                }

                if (!this.sidebarClick && (this.overlay || !this.isDesktop())) {
                    this.sidebarActive = false;
                }

                if (this.configActive && !this.configClick) {
                    this.configActive = false;
                }

                this.configClick = false;
                this.topbarItemClick = false;
                this.sidebarClick = false;
            }
        );

    }

    onTabClick(event: Event, index: number) {
        if (this.activeTabIndex === index) {
            this.sidebarActive = !this.sidebarActive;
        } else {
            this.activeTabIndex = index;
            this.sidebarActive = true;
        }

        event.preventDefault();
    }

    closeSidebar(event: Event) {
        this.sidebarActive = false;
        event.preventDefault();
    }

    togglePin(event: Event): void {
        this.pinned = !this.pinned;
        this.layoutMode = this.pinned ? 'static' : 'overlay';
        try { localStorage.setItem('sidebarPinned', this.pinned ? '1' : '0'); } catch { /* sin storage */ }
        this.sidebarClick = true;      // evita que el clic cierre el menú
        event.preventDefault();
    }

    onSidebarClick($event) {
        this.sidebarClick = true;
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRippleChange(event) {
        this.ripple = event.checked;
    }

    get overlay(): boolean {
        return this.layoutMode === 'overlay';
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }
}
